import MetaTags from "react-meta-tags"
import React from "react"
import { Container } from "reactstrap"
import LedgerTable from "../../components/Ledger"

const Ledgers = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Ledgers | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <LedgerTable />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Ledgers
